import { create } from 'zustand'
import axios from 'axios'
import { cleanParamsFilter } from 'Utils/cleanParamsFilter'

import { CRUDBaseStore } from './Base/CRUD'

export const API_SLUG = 'pile'

export const INITIAL_STATE = {
  id: 0,
  itemCode: '',
  itemTitle: '',
  height: '',
  width: '',
  weight: '',
  createdAt: '',
  updatedAt: '',
  message: '',
}

export interface MachineStore extends CRUDBaseStore {
  getOne: (id: any) => Promise<{ success: boolean; data: any }>
}



export const usePileStore = create<MachineStore>((set, get) => ({
  data: [],
  error: undefined,
  loading: false,
  selected: INITIAL_STATE,
  setError: error => set({ error }),
  setSelected: selected => set({ selected }),
  setLoading: loading => set({ loading }),
  getAll: async (params = {}) => {
    try {
      const response = await axios.get(`/${API_SLUG}`, {
        params: cleanParamsFilter(params),
      })
      set({ data: response.data })

      return {
        success: true,
        data: response.data,
      }
    } catch (error: any) {
      set({ error })

      return {
        success: false,
        data: error?.response?.data?.toString(),
      }
    }
  },
  getOne: async (id: any) => {
    try {
      const response = await axios.get(`/${API_SLUG}/${id}`)
      set({ selected: response.data })

      return {
        success: true,
        data: response.data,
      }
    } catch (error: any) {
      set({ error })
      return {
        success: false,
        data: error?.response?.data?.toString(),
      }
    }
  },

  create: async data => {
    const formData = new FormData()
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key])
      }
    })

    try {
      const response = await axios.post(`/${API_SLUG}`, formData)

      return {
        success: true,
        data: response.data,
      }
    } catch (error: any) {
      set({ error })

      return {
        success: false,
        data: error?.response?.data,
      }
    }
  },
  edit: async (id, data) => {
    const formData = new FormData()
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key])
      }
    })

    try {
      const response = await axios.patch(`/${API_SLUG}/${id}`, formData)

      return {
        success: true,
        data: response.data,
      }
    } catch (error: any) {
      set({ error })

      return {
        success: false,
        data: error?.response?.data?.toString(),
      }
    }
  },
  delete: async id => {
    try {
      const response = await axios.delete(`/${API_SLUG}/${id}`)

      return {
        success: true,
        data: response.data,
      }
    } catch (error: any) {
      set({ error })

      return {
        success: false,
        data: error?.response?.data?.toString(),
      }
    }
  },
  clearState: () =>
    set({
      data: [],
      error: undefined,
      loading: false,
      selected: INITIAL_STATE,
    }),
}))
